import { render, staticRenderFns } from "./PU_details_pr.vue?vue&type=template&id=64046ee6&scoped=true&"
import script from "./PU_details_pr.vue?vue&type=script&lang=js&"
export * from "./PU_details_pr.vue?vue&type=script&lang=js&"
import style0 from "./PU_details_pr.vue?vue&type=style&index=0&id=64046ee6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64046ee6",
  null
  
)

export default component.exports